import Add16 from '@carbon/icons-react/es/add/16';
import { FC } from 'react';
import { Button, ButtonProps } from 'components/atoms/button/button';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';

const BaseAddButton: FC<React.PropsWithChildren<ButtonProps>> = (props) => (
  <Button icon={<Add16 />} type="primary" iconPlacement="right" {...props} />
);

export const AddButton = withHideIfNotAllowed(BaseAddButton);
